import { useEffect } from "react";
import LocationPermissionBanner from "../location/LocationPermissionBanner";
import { useGeolocation } from "../../hooks/useGeolocation";

export default function LocationSettingsCard() {
  const { position, locating, denied, usingSaved, locate, loadSavedLocation } =
    useGeolocation({
      autoLocate: false,
    });

  useEffect(() => {
    loadSavedLocation();
  }, [loadSavedLocation]);

  return (
    <div className="zx-card space-y-4 p-5" data-testid="account-location-card">
      <div>
        <p className="zx-label">Ubicación</p>
        <p className="mt-1 text-[11px] leading-relaxed text-[rgba(255,255,255,0.55)]">
          Se usa para mostrar hoteles y encuentros cerca de ti. Puedes volver a
          activar el permiso cuando quieras.
        </p>
      </div>

      {position && !denied && (
        <p className="font-mono text-[11px] text-[rgba(255,255,255,0.65)]">
          Última posición: {position.lat.toFixed(4)}, {position.lng.toFixed(4)}
          {usingSaved ? " · guardada" : " · actualizada"}
        </p>
      )}

      {(denied || !position) && (
        <LocationPermissionBanner
          onRetry={() => locate({ preferSaved: true })}
          locating={locating}
          usingSaved={usingSaved && !!position}
        />
      )}

      {!denied && position && (
        <button
          type="button"
          onClick={() => locate({ preferSaved: false })}
          disabled={locating}
          className="rounded-full border border-[rgba(255,255,255,0.12)] px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.75)] hover:border-[rgba(255,255,255,0.3)] disabled:opacity-50"
          data-testid="account-location-refresh"
        >
          {locating ? "Actualizando…" : "Actualizar ubicación"}
        </button>
      )}
    </div>
  );
}
